import { User } from '../user'

async function deleteUserData(localRepo) {
  const userData = await localRepo.delete()
  if (!userData) return null
  const user = new User()
  user.setData(userData)
  return user
}

export default deleteUserData
